import React from 'react';
export const SelectionRegionContext = React.createContext('');
const SelectionRegion = ({ regionId = 'selectionRegion', children, }) => (React.createElement(SelectionRegionContext.Provider, { value: regionId },
    React.createElement("div", { "data-region-selector-id": regionId }, children)));
export { SelectionRegion };
//# sourceMappingURL=SelectionRegion.js.map